import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { alpha, styled } from "@mui/material/styles";
import TreeItem, { TreeItemProps } from "@mui/lab/TreeItem";
import Collapse from "@mui/material/Collapse";
import { useSpring, animated } from "@react-spring/web";
import { TransitionProps } from "@mui/material/transitions";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useEffect, useState } from "react";
import NoPosition from "../../assets/vectors/NoPositionVector.png";
import {
  GetMyPosition,
  GetPositionByParentId,
  GetPositionRoleByPositionIdAndRole,
  GetPositionsTreeByCompanyId,
} from "../../services/PositionService";
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import {
  GetUserProfileById,
  GetUserProfileByIds,
} from "../../services/ProfileService";
import { logDOM } from "@testing-library/react";
import {
  fetchUserPosition,
  getMyPosition,
} from "../../features/position/positionSlice";
import { useDispatch, useSelector } from "react-redux";
import { Tree, TreeDataNode } from "antd";
import { log } from "@grpc/grpc-js/build/src/logging";
import ManagePosition from "./ManagePosition";
//import { GetUserProfileById } from "../../services/ProfileService";

const { TreeNode } = Tree;

const treeData: TreeDataNode[] = [
  {
    title: (
      <div
        style={{
          width: "200px",
          backgroundColor: "transparent",
          textAlign: "center",
          color: "green",
        }}
      >
        <AddCircleOutlineIcon />
      </div>
    ),
    key: "0-0",
    children: [
      {
        title: "parent 1-0",
        key: "0-0-0",
        disabled: true,
        children: [
          {
            title: "leaf",
            key: "0-0-0-0",
            disableCheckbox: true,
          },
          {
            title: "leaf",
            key: "0-0-0-1",
          },
        ],
      },
      {
        title: "parent 1-1",
        key: "0-0-1",
        children: [
          {
            title: <span style={{ color: "#1677ff" }}>sss</span>,
            key: "0-0-1-0",
          },
        ],
      },
    ],
  },
];

function TransitionComponent(props: TransitionProps) {
  const style = useSpring({
    from: {
      opacity: 0,
      transform: "translate3d(20px,0,0)",
    },
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    },
  });

  return (
    <div
    //style={style}
    >
      <Collapse {...props} />
    </div>
  );
}

const StyledTreeItem = styled((props: TreeItemProps) => (
  <TreeItem {...props} TransitionComponent={TransitionComponent} />
))(({ theme }) => ({
  [`& .iconContainer`]: {
    "& .close": {
      opacity: 0.3,
    },
  },
  [`& .group`]: {
    marginRight: 15,
    paddingRight: 18,
    borderRight: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
  },
}));

export default function Positions2() {
  const navigate = useNavigate();

  /* Start Of Checking User Has Position */
  const [myPosition, SetMyPosition] = useState<any>("");
  async function GetMyPositionAsync() {
    await GetMyPosition().then((p) => {
      //	console.log("log", p);

      if (p.status === 200) {
        SetMyPosition(p.data);
      } else {
        SetMyPosition(null);
      }
    });
  }

  /* End Of Checking  */

  const [getPositions, setPositions] = useState<any>([]);
  const [getUsers, setUsers] = useState<any>([]);
  const [expand, setExpand] = useState<any>([]);
  const [invitationCode, setInvitationCode] = useState<any>(null);

  async function GetData() {
    return await GetPositionByParentId("");
  }

  const location = useLocation();

  useEffect(() => {
    //console.log("Route changed to", location.pathname);
    GetMyPositionAsync();
    if (myPosition !== null && myPosition !== "") {
      GetData().then((p) => setPositions(p.data));
    }
  }, [location]);

  const dispatch = useDispatch<any>();
  const setActiveIndex = useOutletContext();

  useEffect(() => {
    // console.log("location", location.pathname.includes("/Confirm/Positions"));
    if (location.pathname.includes("/Confirm/Positions")) {
      (setActiveIndex as any)(5);
      setInvitationCode(localStorage.getItem("invitationCode"));
    }
    GetMyPositionAsync();
    if (myPosition !== null && myPosition !== "") {
      GetData().then((p) => setPositions(p.data));
    }
    GetPositionsTreeByCompanyId().then((p) => {
      console.log("setTreeDataState", p.data.data);

      setFilteredKeys(collectKeys(p.data.data));

      setTreeDataState(
        updateNodeTitle(
          p.data.data,
          "new",
          <div
            style={{
              width: "200px",
              backgroundColor: "transparent",
              textAlign: "center",
              color: "green",
            }}
          >
            <AddCircleOutlineIcon />
          </div>
        )
      );
      // setTreeDataState();
    });
    dispatch(fetchUserPosition());
  }, []);
  const [getRefresh, setRefresh] = useState<any>(false);

  const Refresh = () => {
    GetMyPositionAsync();
    if (myPosition !== null && myPosition !== "") {
      GetData().then((p) => setPositions(p.data));
    }
    GetPositionsTreeByCompanyId().then((p) => {
      console.log("setTreeDataState", p.data.data);

      setFilteredKeys(collectKeys(p.data.data));

      setTreeDataState(
        updateNodeTitle(
          p.data.data,
          "new",
          <div
            style={{
              width: "200px",
              backgroundColor: "transparent",
              textAlign: "center",
              color: "green",
            }}
          >
            <AddCircleOutlineIcon />
          </div>
        )
      );
      // setTreeDataState();
    });
    dispatch(fetchUserPosition());
  };

  const myPositions = useSelector(getMyPosition);
  useEffect(() => {
    if (myPositions) {
      if (myPositions.positions.name !== undefined) {
        GetPositionRoleByPositionIdAndRoleAsync();
      }
    }
  }, [myPositions]);

  const [ChangePosition, setChangePosition] = React.useState(false);
  async function GetPositionRoleByPositionIdAndRoleAsync() {
    await GetPositionRoleByPositionIdAndRole(
      myPositions.positions.id,
      "ChangePosition"
    ).then((p) => setChangePosition(p.data.data));
  }

  useEffect(() => {
    if (myPosition !== null && myPosition !== "") {
      GetData().then((p) => setPositions(p.data));
    }
  }, [myPosition]);

  useEffect(() => {
    //console.log("expand", expand);
  }, [expand]);
  //   useEffect(() => {
  //     if (getPositions !== null && getPositions !== "") {
  //       console.log(getPositions);
  //       getPositions.map((p: any) => {
  //         add(p.id);
  //         //console.log("p", p);
  //         p.positions?.map((p1: any) => {
  //           add(p1.id);
  //           //console.log("p1", p1);
  //           p1.positions?.map((p2: any) => {
  //             add(p2.id);
  //             //console.log("p2", p2);
  //             p2.positions?.map((p3: any) => {
  //               add(p3.id);
  //               //console.log("p3", p3);
  //             });
  //           });
  //         });
  //       });
  //     }
  //   }, [getPositions]);

  function addItemToUsers(userId: string, name: string) {
    const newItem = { userId, name };

    // Check if the item already exists in the array
    const itemExists = getUsers.some((user: any) => user.userId === userId);

    if (!itemExists) {
      // Add the new item to the array
      setUsers((prevUsers: any) => [...prevUsers, newItem]);
    }
  }

  useEffect(() => {
    console.log("getusers", getUsers);
  }, [getUsers]);

  async function getUserInfoById(id: any) {
    const userInfo = await GetUserProfileById(id);
    return await userInfo.data;
  }

  /////////////////

  const onSelect = (selectedKeys: React.Key[], info: any) => {
    if (selectedKeys[0] !== undefined) {
      setSelectedKeys(selectedKeys);
      console.log("selected", selectedKeys, info);
      if (selectedKeys[0].toString().includes("new")) {
        //navigate(`Manage/New/${info.node.parentId}`);
        setNodeId(info.node.parentId.toString());

        setFlag("new");
      } else {
        setFlag("");
        // navigate(`/ManagePositions/${selectedKeys[0]}`);
        setNodeId(selectedKeys[0].toString());
      }
    }
  };
  const [flag, setFlag] = useState("");
  const [nodeId, setNodeId] = useState("");

  const [showIcon, setShowIcon] = useState<boolean>(false);
  const [showLine, setShowLine] = useState<boolean>(true);
  const [showLeafIcon, setShowLeafIcon] = useState<React.ReactNode>(true);
  const [treeDataState, setTreeDataState] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
  const [filteredKeys, setFilteredKeys] = useState<string[]>([]);
  const [getFindUsers, setFinedUsers] = useState<any>([]);

  const collectKeys = (nodes: any): string[] => {
    let keys: string[] = [];

    nodes.forEach((node: any) => {
      if (node.title !== "new") {
        //console.log("node", node);

        keys.push(node.userId);
      }
      if (node.children && node.children.length > 0) {
        keys = keys.concat(collectKeys(node.children));
      }
    });

    return keys;
  };

  const updateNodeTitle = (data: any, oldTitle: any, newTitle: any) => {
    return data.map((item: any) => {
      if (item.title === oldTitle) {
        return { ...item, title: newTitle };
      }
      if (item.children) {
        return {
          ...item,
          children: updateNodeTitle(item.children, oldTitle, newTitle),
        };
      }
      return item;
    });
  };

  useEffect(() => {
    console.log("filteredKeys.length ", filteredKeys.length);

    if (filteredKeys.length > 0) {
      GetUserProfileByIds(filteredKeys).then((p: any) => {
        console.log("xx", p);
        setFinedUsers(p.data.data);
      });
    }

    console.log("filteredKeys", filteredKeys);
  }, [filteredKeys]);

  useEffect(() => {
    console.log("get", getPositions);
    getPositions.map((p: any) => {
      console.log("dd", p);
    });
  }, [getPositions]);

  return (
    <>
      {myPosition !== null ? (
        <>
          {" "}
          <div className="col-12" style={{ display: "inline-flex" }}>
            <div
              className="col-6 mx-2"
              style={{ backgroundColor: "transparent" }}
            >
              <>
                <Tree
                  showLine={showLine ? { showLeafIcon } : false}
                  showIcon={showIcon}
                  onSelect={onSelect}
                  selectedKeys={selectedKeys}
                  treeData={treeDataState}
                  titleRender={(node: any) => (
                    <span>
                      {node.title}
                      {getFindUsers.findIndex(
                        (o: any) => o.userId === node.userId
                      ) > -1
                        ? "(" +
                          getFindUsers[
                            getFindUsers.findIndex(
                              (o: any) => o.userId === node.userId
                            )
                          ].firstName +
                          " " +
                          getFindUsers[
                            getFindUsers.findIndex(
                              (o: any) => o.userId === node.userId
                            )
                          ].lastName +
                          ")"
                        : ""}
                    </span>
                  )}
                />
              </>
            </div>
            <div
              className="col-6"
              style={{
                backgroundColor: "transparent",
              }}
            >
              <div
                style={{
                  backgroundColor: "transparent",
                  margin: "auto",
                }}
              >
                {ChangePosition === true && nodeId !== "" ? (
                  <>
                    <ManagePosition
                      positionId={nodeId}
                      flag={flag}
                      setRefresh={Refresh}
                    />
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {" "}
          <div
            className="mt-5 iran"
            style={{ textAlign: "center", margin: "auto" }}
          >
            <p>کاربر گرامی شما دارای هیچ سمتی در هیچ فروشگاهی نمیباشید . </p>
            <img height={300} width={300} src={NoPosition} />
          </div>
        </>
      )}
    </>
  );
}
